import "../assets/css/Home.css";
import React from "react";
import Navbar from "./navigation";
import RightArrow from "../assets/img/right_arrow.svg";
import { useState, useEffect, useRef } from "react";
import ReactPlayer from "react-player/vimeo";
import { ReactComponent as MindMapping } from "../assets/img/mind_mapping.svg";
import { ReactComponent as Planning } from "../assets/img/shield.svg";
import { ReactComponent as TakeControl } from "../assets/img/take_control.svg";
import DownArrow from "../assets/img/arrow-down.svg";
import UpArrow from "../assets/img/arrow-up.svg";
import Testimonies from "./Testimonies";
import FooterLogo from "../assets/img/footer_logo.jpg";
import { ReactComponent as Facebook } from "../assets/img/facebook.svg";

import { ReactComponent as LinkedIn } from "../assets/img/linkedin.svg";
import { ServiceMiddleSection } from "./Services";
import { ReactComponent as Instagram } from "../assets/img/instagram.svg";
import { ReactComponent as Email } from "../assets/img/email.svg";
import InvestmentCred from "../assets/img/investment_cred.png";
import StockEarnings from "../assets/img/stock-earnings.png";
import Experience from "../assets/img/man-success-svgrepo-com.png";
import Shield from "../assets/img/shield-dollar-svgrepo-com.png";
import Clock from "../assets/img/clock-svgrepo-com.png";
import { useNavigate } from "react-router-dom";
import BookCover from "../assets/img/book-cover1.png";
import { usePanel } from "./PanelContext";
import PayPalComponent from "./PayPal";
import { ClipLoader } from "react-spinners";
import { InlineWidget } from "react-calendly";
import { HandleBookSubmit } from "./SubmitBackEnd";
import { v4 as uuidv4 } from "uuid";

import Select from "react-select";
import GoldBrain from "../assets/img/gold-brain.png";
import GoldLock from "../assets/img/gold-lock.png";
import GoldHandShake from "../assets/img/gold-handshake.png";
import { SingleValue, ActionMeta } from "react-select";

import {
  metaTrackButtonClick,
  metaClosePopUp,
  metaHandleFirstInput,
} from "./MetaPixelFunctions";

const Home: React.FC = () => {
  const { isOpen, togglePanel } = usePanel();
  return (
    <div className="Home">
      <header className="Home-header">
        <Navbar />
      </header>
      <main>
        <div className="top-body">
          <TopSection />
          <hr />
          <MiddleSection />
          <hr />
          {isOpen && <BookConsultationPopUp />}
          <WhyChooseUs />
          <hr />
          <ServiceMiddleSection />

          <Testimonies />
          <hr />
          <Footer />
        </div>
      </main>
    </div>
  );
};

const TopSection: React.FC = () => {
  const { isOpen, togglePanel } = usePanel();
  return (
    <div className="top-section">
      <div className="top-div-section">
        <h1 className="full-potential">
          Shield Your Retirement from Looming Tax Hikes & Long-Term Care Costs
        </h1>
        <hr />
        <p>
          <b>
            <u>Tax rates</u>
          </b>{" "}
          are on track to rise, and{" "}
          <b>
            <u>unexpected healthcare expenses</u>
          </b>{" "}
          can deplete your savings faster than you think.{" "}
        </p>
        <p></p>
        <p style={{ fontWeight: "bold" }}>
          {" "}
          💡Discover 10 Blind Spots in retirement that can force you to work
          longer in our FREE book:{" "}
          <b>
            <i>Retire with Simplicity and Clarity</i>
          </b>
        </p>

        <div className="big-button-container">
          <div>
            <img src={BookCover} className="book-cover" />
          </div>

          <div className="button-disclaimer-container">
            {/* <a className="big-test-button" href="/assessment"> */}
            {/*   Get My Free Book & Consultation */}
            {/*   <img className="right-arrow" src={RightArrow} /> */}
            {/* </a> */}
            <button
              className="big-test-button"
              onClick={() => {
                metaTrackButtonClick();
                togglePanel();
                document.body.classList.add("no-scroll");
              }}
            >
              Get My Free Book & Consultation
              <img className="right-arrow" src={RightArrow} />
            </button>

            <div className="book-disclaimer">
              <p>
                <i>
                  Just cover shipping ($4.99). Limited copies available.
                  <br />
                  Discover how to protect your wealth today.
                </i>
              </p>
            </div>
          </div>
        </div>
        <div className="trust-bar">
          <span>
            <img className="investment-cred-icon" src={Shield} /> Registered
            Investment Advisor
          </span>
          <span>
            <img className="experience-icon" src={Clock} /> 30+ Years of
            Tax-Free Income Planning Experience{" "}
          </span>
          <span>
            <img className="stock-earnings-icon" src={StockEarnings} /> Expert
            Dividend Portfolio Management{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

const MiddleSection: React.FC = () => {
  const [isMobile, setIsMobile] = useState<Boolean>(false); //useState for checking if the resolution is mobile
  const [openPanel, setOpenPanel] = useState<number | null>(null); //useState for

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, [isMobile]);
  const togglePanel = (panel: number) => {
    if (isMobile) {
      setOpenPanel(openPanel === panel ? null : panel);
    }
  };

  return (
    <div className="three-panel-container">
      <div className="container-middle">
        <div className="left-panel">
          <button
            className="panel-collapsible"
            onClick={() => {
              togglePanel(1);
            }}
          >
            <div className="mind-icon-wrapper">
              <MindMapping className="mind-icon" />
            </div>
            <h3>Secure Peace of Mind</h3>

            <p
              className={`panel-content ${isMobile && openPanel !== 1 ? "collapsed" : ""}`}
            >
              Unlock strategies to mitigate any long term care event. Learn the
              strategies that are superior to traditional policies.
            </p>
            <div className="down-arrow-container">
              <img
                className={`down-arrow ${isMobile && openPanel !== 1 ? "" : "collapsed"}`}
                src={DownArrow}
              />
              <img
                className={`down-arrow ${isMobile && openPanel !== 1 ? "collapsed" : ""}`}
                src={UpArrow}
              />
            </div>
          </button>
        </div>

        <div className="middle-panel">
          <button
            className="panel-collapsible"
            onClick={() => {
              togglePanel(2);
            }}
          >
            <div className="takecontrol-icon-wrapper">
              <TakeControl className="takecontrol-icon" />
            </div>

            <h3>Take Control</h3>

            <p
              className={`panel-content ${isMobile && openPanel !== 2 ? "collapsed" : ""}`}
            >
              Now is the time to build a tax-free retirement strategy that
              balances growth, risk management, and evolving market conditions.
              Our certified advisors are rigorously screened to ensure that
              every recommendation is backed by deep expertise, and a commitment
              to your long-term financial success.
            </p>
            <div className="down-arrow-container">
              <img
                className={`down-arrow ${isMobile && openPanel !== 2 ? "" : "collapsed"}`}
                src={DownArrow}
              />
              <img
                className={`down-arrow ${isMobile && openPanel !== 2 ? "collapsed" : ""}`}
                src={UpArrow}
              />
            </div>
          </button>
        </div>
        <div className="right-panel">
          <button
            className="panel-collapsible"
            onClick={() => {
              togglePanel(3);
            }}
          >
            <div className="planning-icon-wrapper">
              <Planning className="planning-icon" />
            </div>
            <h3>Defend Your Retirement</h3>
            <p
              className={`panel-content ${isMobile && openPanel !== 3 ? "collapsed" : ""}`}
            >
              Tax rates are set to go much higher. Learn how to do an optimal
              Roth conversion that is not known by many.{" "}
            </p>
            <div className="down-arrow-container">
              <img
                className={`down-arrow ${isMobile && openPanel !== 3 ? "" : "collapsed"}`}
                src={DownArrow}
              />
              <img
                className={`down-arrow ${isMobile && openPanel !== 3 ? "collapsed" : ""}`}
                src={UpArrow}
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

function VideoSection() {
  interface VimeoPlayerProps {
    className?: string;
  }
  const VimeoPlayer: React.FC<VimeoPlayerProps> = () => {
    return (
      <ReactPlayer
        className="react-player"
        url="https://vimeo.com/1056474059/8a9dbb141d?ts=0&share=copy"
        playing={true} // ✅ Auto-plays the video
        loop={true} // ✅ Loops infinitely
        controls={false} // ✅ Hides all controls
        muted={true} // ✅ Ensures autoplay works
      />
    );
  };
  return (
    <div className="outer-video-container">
      <div className="inner-video-container">
        <div className="panel-on-video">
          <h3>🔐 Secure your future, your freedom</h3>
          <hr />
          <p>
            Safeguard a tax-free retirement so you can travel, explore, and live
            on your terms.
          </p>
          <p style={{ fontWeight: "bold" }}>
            👉 Take the 60-second quiz to start your journey.
          </p>
          <div className="big-button-container">
            <a className="big-test-button" href="/assessment">
              Take the Quiz
              <img className="right-arrow" src={RightArrow} />
            </a>
          </div>
        </div>
        <VimeoPlayer className="vimeo-player" />
      </div>
    </div>
  );
}
export const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleIconClick = (e: MouseEvent) => {};
  return (
    <div className="footer-container">
      <div className="logo-description">
        <img
          src={FooterLogo}
          className="footer-logo"
          alt="Tax Free Council Logo"
        />
      </div>
      <div className="contact-us">
        <h2>Contact Us</h2>
        <div className="email-div">
          <Email className="email-icon" />
          <p>advising@taxfreecouncil.org</p>
        </div>
      </div>
      <div className="links-container">
        <div className="conditions-container">
          <h2>Conditions</h2>
          <ul>
            <li>Terms & Conditions</li>
            <li>Privacy Policy</li>
          </ul>
        </div>
      </div>

      <div className="social-media-container">
        <h2>Connect With Us</h2>
        <div className="media-icons-container">
          <div className="icon-div">
            <Facebook className="facebook-icon" />
          </div>

          <div className="icon-div">
            <Instagram className="instagram-icon" />
          </div>

          <div className="icon-div">
            <LinkedIn className="linkedin-icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

const WhyChooseUs: React.FC = () => {
  return (
    <div className="why-choose-us-main">
      <div className="why-choose-us-header">
        <h1>Why Choose Us</h1>
      </div>
      <div className="accomplishments-container">
        <div className="accomplishments-wrapper">
          <img src={GoldBrain} className="gold-brain-img" />
          <h3>30+ Years Guiding Retirees to a Tax-Free Future</h3>
        </div>

        <div className="accomplishments-wrapper">
          <img src={GoldLock} className="gold-lock-img" />
          <h3>Certified Tax-Free Income Specialist • Licensed Fiduciary</h3>
          {/* <div className="license-list"> */}
          {/*   <ul> */}
          {/*     <li>Licensed Advisor</li> */}
          {/*     <li>Certified Tax Free Income Specialists</li> */}
          {/*     <li>Filler</li> */}
          {/*   </ul> */}
          {/* </div> */}
        </div>
        <div className="accomplishments-wrapper">
          <img src={GoldHandShake} className="gold-handshake-img" />
          <h3>100% Personalized Strategy Sessions - No Sales Pressure </h3>
        </div>
      </div>
    </div>
  );
};

export const BookConsultationPopUp: React.FC = () => {
  const { isOpen, togglePanel } = usePanel();

  const [isCalendlyActive, setCalendlyActive] = useState(false);

  const openCalendly = () => {
    setCalendlyActive(true);

    document.body.classList.add("no-scroll");
  };
  const closeCalendly = () => {
    setCalendlyActive(false);
  };
  const [formData, setFormData] = useState({
    // User Information
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
  });
  // useEffect(() => {
  // console.log(formData);
  // });
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  useEffect(() => {
    // useEffect will run code automatically once formData changes
    setIsFormValid(
      formData.firstName.trim() !== "" &&
        formData.lastName.trim() !== "" &&
        formData.email.trim() !== "" &&
        formData.phoneNumber.trim() !== "" &&
        formData.address.trim() !== "" &&
        formData.city.trim() !== "" &&
        formData.state.trim() !== "" &&
        formData.zipCode.trim() !== "",
    );
  }, [formData]);
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const tokenRef = useRef<string>(uuidv4());

  useEffect(() => {
    if (isCalendlyActive && !hasSubmitted) {
      HandleBookSubmit(formData, tokenRef.current, setIsLoading);
      setHasSubmitted(true);
    }
  }, [isCalendlyActive, tokenRef.current, hasSubmitted]);

  return (
    <div>
      <div className="popup-overlay active"></div>
      <div className="popup-form active">
        <div className="close-popup-container">
          <button
            className="close-popup"
            onClick={() => {
              metaClosePopUp();
              togglePanel();
              document.body.classList.remove("no-scroll");
            }}
          >
            X
          </button>
        </div>
        {!isCalendlyActive && (
          <div className="form-container">
            <h3>
              Claim Your FREE Retirement Planning Book + Consultation — Just
              $4.99 for Shipping & Handling!
            </h3>

            <div className="form-list-paypal">
              <div className="form-row-paypal">
                <label>
                  First name *{" "}
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    onFocus={metaHandleFirstInput}
                    required
                  />
                </label>
              </div>
              <div className="form-row-paypal">
                <label>
                  Last name *{" "}
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </label>
              </div>
              <div className="form-row-paypal">
                <label>
                  Email *
                  <input
                    type="text"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </label>
              </div>
              <div className="form-row-paypal">
                <label>
                  Phone Number *
                  <input
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                  />
                </label>
              </div>
              <div className="address-zip-container">
                <div className="form-row-paypal-address">
                  <label>
                    Address *
                    <input
                      type="text"
                      name="address"
                      placeholder="Address"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </label>
                </div>
                <div className="form-row-paypal-zip">
                  <label>
                    Zip Code *
                    <input
                      type="text"
                      name="zipCode"
                      placeholder="Zip Code"
                      value={formData.zipCode}
                      onChange={handleChange}
                      required
                    />
                  </label>
                </div>
              </div>
              <div className="city-state-container">
                <div className="form-row-paypal-city">
                  <label>
                    City *
                    <input
                      type="text"
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleChange}
                      required
                    />
                  </label>
                </div>
                <div className="form-row-paypal-state">
                  <label>State *</label>
                  <StateSelector
                    value={formData.state}
                    onChange={(value) =>
                      setFormData((prev) => ({ ...prev, state: value }))
                    }
                  />
                </div>
              </div>
            </div>
            <div className="paypal-container" onClick={openCalendly}>
              <PayPalComponent
                isFormValid={isFormValid}
                setCalendlyActive={setCalendlyActive}
              />
            </div>
          </div>
        )}
        {isCalendlyActive && (
          <div className="calendly-container">
            <h3>✅ Thank you! Your book is on its way... </h3>
            <p>
              You're one step away from maximizing your retirement potential.
              Schedule your complimentary 30-minute private session below to get
              personalized strategies for a tax-free retirement. 👇
            </p>
            <div className="calendly-inline-widget">
              <InlineWidget
                url={`https://calendly.com/ronmark/tax-free-30-minute-meeting?utm_campaign=assessment&utm_content=${tokenRef.current}`}
              ></InlineWidget>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
type OptionType = {
  label: string;
  value: string;
};

type StateSelectorProps = {
  value: string;
  onChange: (value: string) => void;
};

const StateSelector: React.FC<StateSelectorProps> = ({ value, onChange }) => {
  const states = [
    { label: "AL", value: "AL" },
    { label: "AK", value: "AK" },
    { label: "AZ", value: "AZ" },
    { label: "AR", value: "AR" },
    { label: "CA", value: "CA" },
    { label: "CO", value: "CO" },
    { label: "CT", value: "CT" },
    { label: "DE", value: "DE" },
    { label: "FL", value: "FL" },
    { label: "GA", value: "GA" },
    { label: "HI", value: "HI" },
    { label: "ID", value: "ID" },
    { label: "IL", value: "IL" },
    { label: "IN", value: "IN" },
    { label: "IA", value: "IA" },
    { label: "KS", value: "KS" },
    { label: "KY", value: "KY" },
    { label: "LA", value: "LA" },
    { label: "ME", value: "ME" },
    { label: "MD", value: "MD" },
    { label: "MA", value: "MA" },
    { label: "MI", value: "MI" },
    { label: "MN", value: "MN" },
    { label: "MS", value: "MS" },
    { label: "MO", value: "MO" },
    { label: "MT", value: "MT" },
    { label: "NE", value: "NE" },
    { label: "NV", value: "NV" },
    { label: "NH", value: "NH" },
    { label: "NJ", value: "NJ" },
    { label: "NM", value: "NM" },
    { label: "NY", value: "NY" },
    { label: "NC", value: "NC" },
    { label: "ND", value: "ND" },
    { label: "OH", value: "OH" },
    { label: "OK", value: "OK" },
    { label: "OR", value: "OR" },
    { label: "PA", value: "PA" },
    { label: "RI", value: "RI" },
    { label: "SC", value: "SC" },
    { label: "SD", value: "SD" },
    { label: "TN", value: "TN" },
    { label: "TX", value: "TX" },
    { label: "UT", value: "UT" },
    { label: "VT", value: "VT" },
    { label: "VA", value: "VA" },
    { label: "WA", value: "WA" },
    { label: "WV", value: "WV" },
    { label: "WI", value: "WI" },
    { label: "WY", value: "WY" },
  ];
  const selectedOption = states.find((opt) => opt.value === value) || null;
  return (
    <Select
      className="state-select"
      options={states}
      value={selectedOption}
      onChange={(option) => {
        if (option) onChange(option.value);
      }}
      // onChange={(
      //   selectedOption: SingleValue<{
      //     label: string;
      //     value: string;
      //   }>,
      //   actionMeta: ActionMeta<{ label: string; value: string }>,
      // ) => handleStateChange(selectedOption, index)}
      styles={{
        control: (base) => ({
          ...base,
          cursor: "pointer",
          borderRadius: "25px",
        }),
      }}
      placeholder="Select..."
    />
  );
};
export default Home;
